import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Recipe } from '../Models/recipe';
import { environment } from 'src/environments/environment';
import { SearchService } from '../search.service';


@Component({
  selector: 'app-edit-recipe',
  templateUrl: './edit-recipe.component.html'
})
export class EditRecipeComponent implements OnInit {

  id: number;
  recipe: Recipe;

  constructor(
    public router: Router, 
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    public searchSvc: SearchService
  ) { 
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  ngOnInit() {
    this.recipe = new Recipe();

    if (this.id < 0) {
      return;
    }

    this.httpClient.get(environment.apiUrl + '/get?id=' + this.id).subscribe((r: Recipe) => {
      this.recipe = r;

      // this.recipe.Ingredients = this.recipe.Ingredients;
      // this.recipe.Directions = this.recipe.Directions;
      // this.recipe.Cookbook = this.recipe.Cookbook;
    });
  }

  saveRecipe() {
    this.httpClient.post(environment.apiUrl + '/save', this.recipe).subscribe((newID: number) => {
      this.router.navigate(['/recipe', newID]);
    });
  }

  cancel() {
    this.router.navigate(['/recipe', this.id]);
  }
}
